import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";

import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { set } from "firebase/database";
import { getSettings } from '../api/settings';

export const fetchSettings= () => async (dispatch) => {
  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });

  try {
    const data = await getSettings();

    if (data) {
      dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload: data,
      });
    } else {
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: "Unable to fetch settings.",
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_SETTINGS_FAILED,
      payload: error && error.message ? error.message : "Unable to fetch settings.",
    });
  }
};

export const editSettings = (settings) => (dispatch) => {
  const {
    settingsRef
  } = firebase;
  dispatch({
    type: EDIT_SETTINGS,
    payload: settings
  });
  set(settingsRef, settings);
  alert(store.getState().languagedata.defaultLanguage.updated);
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};